<template>
  <v-text-field
    v-model="currentValue"
    class="bh-input-pill-component rounded-pill"
    color="accent"
    height="48px"
    append-icon="bhi-loupe"
    :placeholder="placeholder"
    :background-color="bgColor"
    :disabled="disabled"
    filled
    clearable
    hide-details
    :full-width="fullWidth"
    @input="$emit('input', $event)"
    @click:clear="$emit('click:clear')"
    @click:append="$emit('click:append')"
    @keydown.enter="$emit('keydown.enter', value)"
  />
</template>
<script>
export default {
  name: 'BhInputPill',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    appendIcon: {
      type: String,
      default: undefined
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputBackgroundClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentValue: ''
    }
  },
  created () {
    this.currentValue = this.value
  }
}
</script>

<style lang="scss">
// cannot be scoped
.bh-input-pill-component {
  margin: 0 8px !important;

  &.v-select {
    width: 120px;
  }

  .v-select__slot,
  .v-input__slot {
    align-items: center;
    height: 48px;
    min-height: 0 !important;

    &::before,
    &::after {
      content: "";
      display: none;
    }

    .v-input__append-inner {
      align-self: center;
      margin-top: 0 !important;
      padding-right: 5px;
    }

    .v-icon {
      color: $bh-blue;
    }
  }
}
</style>